import { useState } from 'react';

export const useAppModals = () => {
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [showAddJobModal, setShowAddJobModal] = useState(false);
  const [showTreatmentReportEditor, setShowTreatmentReportEditor] = useState(false);
  const [showAddAppointmentModal, setShowAddAppointmentModal] = useState(false);
  const [showEditAppointmentModal, setShowEditAppointmentModal] = useState(false);
  const [editingTreatmentReport, setEditingTreatmentReport] = useState(null);
  const [editingJob, setEditingJob] = useState(null);
  const [editingAppointment, setEditingAppointment] = useState(null);
  const [appointmentInitialData, setAppointmentInitialData] = useState(null);
  const [showCustomerSearchModal, setShowCustomerSearchModal] = useState(false);
  const [preSelectedCustomer, setPreSelectedCustomer] = useState(null);
  const [addJobMode, setAddJobMode] = useState('job'); // 'job' or 'contract'
  const [appointmentVersion, setAppointmentVersion] = useState(0);

  const openAddCustomerModal = () => setShowAddCustomerModal(true);
  const closeAddCustomerModal = () => setShowAddCustomerModal(false);

  const openCustomerSearchModal = (mode = 'job') => {
    setAddJobMode(mode);
    setShowCustomerSearchModal(true);
  };
  const closeCustomerSearchModal = () => setShowCustomerSearchModal(false);

  const openAddJobModal = (job = null) => {
    setEditingJob(job);
    setShowAddJobModal(true);
  };

  const openAddJobModalForCustomer = (customer, mode = 'job') => {
    setPreSelectedCustomer(customer);
    setAddJobMode(mode);
    setEditingJob(null);
    setShowAddJobModal(true);
  };

  const closeAddJobModal = () => {
    setShowAddJobModal(false);
    setEditingJob(null);
    setPreSelectedCustomer(null);
    setAddJobMode('job');
  };

  const openTreatmentReportEditor = (report = null) => {
    setEditingTreatmentReport(report);
    setShowTreatmentReportEditor(true);
  };

  const closeTreatmentReportEditor = () => {
    setShowTreatmentReportEditor(false);
    setEditingTreatmentReport(null);
  };

  const openAddAppointmentModal = (initialData = {}) => {
    setAppointmentInitialData(initialData);
    setShowAddAppointmentModal(true);
  };

  const closeAddAppointmentModal = () => {
    setShowAddAppointmentModal(false);
    setAppointmentInitialData(null);
  };

  const openEditAppointmentModal = (appointment) => {
    setEditingAppointment(appointment);
    setShowEditAppointmentModal(true);
  };

  const closeEditAppointmentModal = () => {
    setShowEditAppointmentModal(false);
    setEditingAppointment(null);
  };

  return {
    // Modal states
    showAddCustomerModal,
    showAddJobModal,
    showTreatmentReportEditor,
    showAddAppointmentModal,
    showEditAppointmentModal,
    editingTreatmentReport,
    editingJob,
    editingAppointment,
    appointmentInitialData,
    showCustomerSearchModal,
    preSelectedCustomer,
    addJobMode,
    appointmentVersion,

    // Modal actions
    openAddCustomerModal,
    closeAddCustomerModal,
    openCustomerSearchModal,
    closeCustomerSearchModal,
    setPreSelectedCustomer,
    openAddJobModal,
    openAddJobModalForCustomer,
    closeAddJobModal,
    openTreatmentReportEditor,
    closeTreatmentReportEditor,
    openAddAppointmentModal,
    closeAddAppointmentModal,
    openEditAppointmentModal,
    closeEditAppointmentModal,
    bumpAppointmentVersion: () => setAppointmentVersion(v => v + 1)
  };
};